import styled from "styled-components";
import DesignConstants from "../../../../../../../constants/DesignConstants";

export const GoodLuckGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: 480px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const GoodLuckImageCard = styled.div<{ isSelected: boolean; disabled: boolean }>`
    border: ${DesignConstants.BORDERS.MEDIUM}
        ${(props) => (props.isSelected ? DesignConstants.COLORS.DARKEST_GREY : DesignConstants.COLORS.LIGHTEST_GREY)};
    border-radius: ${DesignConstants.BORDER_RADIUS.XSMALL_CONTAINER};
    padding: ${DesignConstants.SPACES.XXS};
    display: flex;
    flex-direction: column;
    align-items: center;
    aspect-ratio: 1/1;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.disabled ? DesignConstants.OPACITY.HALF : 1)};

    ${(props) =>
        !props.disabled &&
        `
    &:hover {
        opacity: ${props.isSelected ? 1 : DesignConstants.OPACITY.HALF};
        background-color: ${props.isSelected ? "" : DesignConstants.COLORS.LIGHTEST_GREY};
    }
  `}
`;

export const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
